import {
  LaboratoryBatchItemConsentTag,
  LaboratoryBatchItemDataRevisionTag,
  LaboratoryBatchItemDismissedTag,
} from '@app/modules/laboratory/laboratory.types';

export interface FollowUp {
  id: string;
  referenceKey: string;
  type: FollowUpType;
  reason: string;
  assignee: string;
  link: {
    id: string;
    type: string;
  };
  timeline: FollowUpActivity[];
  notes: string;
  lastStatus: FollowUpStatus;
  lastStatusChanged: string;
  generated: string;
  generatedBy: string;
  inProgress: string;
  inProgressBy: string;
  resolved: string;
  resolvedBy: string;
  archived: string;
  archivedBy: string;
}

export interface ProvisionFollowUp {
  type: FollowUpType;
  reason: string;
  link: {
    id: string;
    type: FollowUpLinkType;
  };
}

export interface FollowUpActivity {
  type: string;
  details: string;
  by: string;
  timestamp: string;
}

export enum FollowUpType {
  WaitingSample = 'WaitingSample',
  ConsentIssue = 'ConsentIssue',
  DismissedSample = 'DismissedSample',
  CancelRequest = 'CancelRequest',
  DataRevision = 'DataRevision',
  ReportRevision = 'ReportRevision',
}

export enum FollowUpCancellationReasons {
  PartnerRequest = 'PartnerRequest',
}

export enum FollowUpLinkType {
  Sample = 'Sample',
  Kit = 'Kit',
  ServiceData = 'ServiceData',
  Report = 'Report',
  Result = 'RawData',
}

export enum FollowUpStatus {
  Generated = 'Generated',
  InProgress = 'InProgress',
  Resolved = 'Resolved',
  Archived = 'Archived',
}

export interface FollowUpsUser {
  id: string;
  name: string;
}

export const FollowUpReasonsByType = {
  [FollowUpType.WaitingSample]: [LaboratoryBatchItemDismissedTag.NotInApp],
  [FollowUpType.ConsentIssue]: [
    LaboratoryBatchItemConsentTag.ConsentMissing,
    LaboratoryBatchItemConsentTag.DoctorSignatureMissing,
    LaboratoryBatchItemConsentTag.PatientSignatureMissing,
  ],
  [FollowUpType.DismissedSample]: [
    LaboratoryBatchItemDismissedTag.Over120h,
    LaboratoryBatchItemDismissedTag.ExpiredTube,
    LaboratoryBatchItemDismissedTag.Hemolysis,
    LaboratoryBatchItemDismissedTag.DamagedTube,
    LaboratoryBatchItemDismissedTag.BloodClot,
    LaboratoryBatchItemDismissedTag.InsufficientVolume,
    LaboratoryBatchItemDismissedTag.KitMixUp,
    LaboratoryBatchItemDismissedTag.TestLimitation,
    LaboratoryBatchItemDismissedTag.LabMistake,
    LaboratoryBatchItemDismissedTag.DHL,
    LaboratoryBatchItemDismissedTag.Other,
  ],
  [FollowUpType.CancelRequest]: [FollowUpCancellationReasons.PartnerRequest],
  [FollowUpType.DataRevision]: [
    LaboratoryBatchItemDataRevisionTag.PackageChange,
    LaboratoryBatchItemDataRevisionTag.BarcodeCorrection,
    LaboratoryBatchItemDataRevisionTag.PatientDataUpdate,
    LaboratoryBatchItemDataRevisionTag.DOVCorrection,
    LaboratoryBatchItemDataRevisionTag.DSV120to125h,
    LaboratoryBatchItemDataRevisionTag.MedicalReviewRequest,
  ],
};
